export default __webpack_public_path__ + "static/media/game_logo.5b306f47.png";